import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import Banner from './component/banner/banner';
import ContentCta from './component/contentCta/content-cta';
import HoverCard from '../home/component/hoverCard/hoverCard';
import NoHoverCard from './component/hoverCard/hoverCard';
import { actionCreators } from './store';

class AboutMe extends Component {

  componentDidMount() {
    this.props.fetchAboutMeData();
    this.props.fetchAboutPageData();
  }

  render () {

    const { contentCta, hoverCard, hoverCardPlus, head } = this.props;
    return (
      <div className="about-me">
        {
          head && <Banner title={head.get('name')} desc={head.get('des')} en={head.get('en')} bannerSrc={head.get('logo')}></Banner>
        }
        {
          contentCta.map((item) => {
            return (
              <ContentCta key={ item.get('id') } content={ item } imgUrl={item.get('imgUrl')} space={ item.get('noSpace') } ></ContentCta>
            )
          })
        }
        <HoverCard hoverCardData={ hoverCard } title="技术专家" hasBackGroud="hasBackGroud"></HoverCard>
        <NoHoverCard hoverCardData={ hoverCardPlus } title="服务团队" noSpaceBottom={true} hideMore={true}></NoHoverCard>
      </div>
    )
  }
}

const mapState = (state) => ({
  contentCta: state.getIn(['about', 'contentCta']),
  hoverCard: state.getIn(['about', 'hoverCard']),
  hoverCardPlus: state.getIn(['about', 'hoverCardPlus']),
  head: state.getIn(['about', 'head'])
})

const mapDispatch = (dispatch) => ({
  fetchAboutPageData() {
    dispatch(actionCreators.fetchAboutPageData());
  },
  fetchAboutMeData() {
    dispatch(actionCreators.fetchAboutMeData());
  }
})

export default connect(mapState, mapDispatch)(AboutMe);
